<template>
  <div v-if="show">
    <el-form label-position="top" size="small" @submit.native.prevent>
      <el-form-item :label="'类型'">
        <el-tag effect="plain">{{ data.type }}</el-tag>
        <el-checkbox
          v-if="data.options.hasOwnProperty('carNumberOptions')"
          style="display: block"
          v-model="data.options.carNumberOptions.isCarNumber"
          disabled
        >
          是否展示为车牌组件
        </el-checkbox>
      </el-form-item>
      <template
        v-if="
          data.type !== 'grid' &&
          data.type !== 'divider' &&
          data.type !== 'comment' &&
          data.type !== 'report' &&
          data.type !== 'td'
        "
      >
        <el-form-item label="标题">
          <el-input v-model="data.name"></el-input>
        </el-form-item>
        <el-form-item label="字段名" v-if="data.type !== 'button'">
          <el-input
            v-if="data.type === 'sonform' || data.type === 'page'"
            v-model="sonFormDataModel"
          >
            <template slot="prepend">
              <span class="custom_span" v-if="data.type === 'sonform'">
                {{
                  sonFormDataModel
                    ? 'sonform_colorful_egg_'
                    : 'sonform_colorful_egg'
                }}
              </span>

              <span class="custom_span" v-if="data.type === 'page'">{{
                sonFormDataModel ? 'page_' : 'page'
              }}</span>
            </template>
            <template #append>
              <span class="custom_span">_{{ data.key }}</span>
            </template>
          </el-input>
          <el-input v-else v-model="data.model" />
        </el-form-item>
        <el-form-item
          label="是否显示标题"
          v-if="
            data.type !== 'hidden' &&
            data.type !== 'page' &&
            data.type !== 'sonform' &&
            data.type !== 'button'
          "
        >
          <el-radio-group v-model="data.showName">
            <el-radio-button :label="true">显示</el-radio-button>
            <el-radio-button :label="false">不显示</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用上传签名照" v-if="data.type == 'esign'">
          <el-radio-group v-model="data.options.isUpdate">
            <el-radio-button :label="true">启用</el-radio-button>
            <el-radio-button :label="false">不启用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item
          label="标签对齐方式"
          v-if="data.type !== 'hidden' && data.type !== 'sonform'  && data.type !== 'page' && data.type !== 'button'"
        >
          <el-select v-model="data.labelPosition">
            <el-option
              value="left"
              label="左对齐"
            ></el-option>
            <el-option
              value="center"
              label="居中对齐"
            ></el-option>
            <el-option
              value="right"
              label="右对齐"
            ></el-option>
            <el-option
              value="top"
              label="顶部对齐"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="标题宽度"
          v-if="
            data.type !== 'hidden' &&
            data.type !== 'sonform' &&
            data.type !== 'page' &&
            data.type !== 'button'
          "
        >
          <el-input-number
            v-model="data.options.labelWidth"
            :min="0"
            :max="600"
            :step="10"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="当前页展示" v-if="data.type === 'textarea'">
          <el-switch v-model="data.options.displayInPage"></el-switch>
        </el-form-item>
        <el-form-item
          label="后缀描述"
          v-if="Object.keys(data).indexOf('suffix') >= 0"
        >
          <el-input
            size="mini"
            v-model.lazy="data.suffix"
            style="width: 240px"
            placeholder="请输入后缀描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="操作属性" v-if="data.type !== 'hidden'">
          <el-checkbox
            v-model="data.options.readonly"
            v-if="Object.keys(data.options).indexOf('readonly') >= 0"
            >完全只读
          </el-checkbox>
          <el-checkbox
            v-model="data.options.disabled"
            v-if="Object.keys(data.options).indexOf('disabled') >= 0"
            >禁用
          </el-checkbox>
          <el-checkbox
            v-model="data.options.hidden"
            v-if="Object.keys(data.options).indexOf('hidden') >= 0"
            >隐藏
          </el-checkbox>
          <el-checkbox
            v-model="data.options.editable"
            v-if="Object.keys(data.options).indexOf('editable') >= 0"
            >文本框可输入
          </el-checkbox>
          <el-checkbox
            v-model="data.options.clearable"
            v-if="Object.keys(data.options).indexOf('clearable') >= 0"
          >
            显示清除按钮</el-checkbox
          >
          <el-checkbox
            v-model="data.options.arrowControl"
            v-if="Object.keys(data.options).indexOf('arrowControl') >= 0"
            >使用箭头进行时间选择</el-checkbox
          >
          <el-checkbox
            v-model="data.options.isDelete"
            v-if="Object.keys(data.options).indexOf('isDelete') >= 0"
            >删除
          </el-checkbox>
          <el-checkbox
            v-model="data.options.isEdit"
            v-if="Object.keys(data.options).indexOf('isEdit') >= 0"
            >编辑
          </el-checkbox>
          <el-checkbox
            v-model="data.options.isShowDetailInput"
            v-if="Object.keys(data.options).indexOf('isShowDetailInput') >= 0"
            >详细地址输入</el-checkbox
          >
        </el-form-item>
        <el-form-item
          label="校验"
          v-if="Object.keys(data.options).indexOf('required') >= 0"
        >
          <div>
            <el-checkbox v-model="data.options.required">必填</el-checkbox>
          </div>
          <el-select
            v-if="Object.keys(data.options).indexOf('dataType') >= 0"
            v-model="data.options.dataType"
            size="mini"
            @change="dataTypeChange"
          >
            <el-option value="string" label="字符串"></el-option>
            <el-option value="number" label="数字"></el-option>
            <!--<el-option value="boolean" label="布尔值"></el-option>-->
            <el-option value="integer" label="整数"></el-option>
            <el-option value="float" label="浮点数"></el-option>
            <el-option value="url" label="URL地址"></el-option>
            <el-option value="email" label="邮箱地址"></el-option>
            <el-option value="hex" label="十六进制"></el-option>
          </el-select>
          <div v-if="Object.keys(data.options).indexOf('pattern') >= 0">
            <el-input
              size="mini"
              v-model.lazy="data.options.pattern"
              style="width: 240px"
              placeholder="填写正则表达式"
            >
            </el-input>
          </div>
        </el-form-item>
      </template>
      <el-form-item label="画笔粗细" v-if="data.type == 'esign'">
        <el-input-number
          v-model="data.options.lineWidth"
          :min="1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="选择关联页面" v-if="data.type === 'page'">
        <el-select
          v-model="data.options.selectPage"
          clearable
          class="sw-config-select"
          placeholder="请选择"
          @change="selectPageValue"
        >
          <el-option
            v-for="(page, key) in sonPages"
            :key="key"
            :label="page.title ? page.title : page.key"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="选择回显字段"
        v-if="data.type === 'page' && data.options.selectPage"
      >
        <el-select
          v-model="data.options.showField"
          class="sw-config-select"
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="field in pageFieldsComputed"
            :key="field.key"
            :label="field.name"
            :value="field.model"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="字符长度"
        v-if="
          Object.keys(data.options).indexOf('length') >= 0 &&
          data.type !== 'imgupload' &&
          data.type !== 'file'
        "
      >
        <el-input-number
          v-model="data.options.length"
          :min="0"
        ></el-input-number>
      </el-form-item>

      <el-form-item
        label="默认值编辑器切换"
        v-if="
          Object.keys(data.options).indexOf('isTextEditor') >= 0 &&
          data.type !== 'divider'
        "
      >
        <el-radio-group
          v-model="data.options.isTextEditor"
          @change="handleChangeValue"
        >
          <el-radio-button :label="false">输入框</el-radio-button>
          <el-radio-button :label="true">富文本</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="样式切换" v-if="data.type == 'divider'">
        <el-radio-group
          v-model="data.options.isTextEditor"
          @change="handleChangeValue"
        >
          <el-radio-button :label="true">样式1</el-radio-button>
          <el-radio-button :label="false">样式2</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="字段（只读）" v-if="data.type == 'divider'">
        <el-input v-model="data.model" readonly=""></el-input>
      </el-form-item>

      <!--新增初始值  -->
      <el-form-item
        label="初始值"
        v-if="Object.keys(data.options).indexOf('initialValue') >= 0"
      >
        <el-button size="mini" type="primary" disabled> 远端接口 </el-button>
        <template>
          <div>
            <template v-if="data.options.isShowSelect">
              <!-- 初始值的选框 -->
              <api-input
                :sel-value.sync="data.options.remoteUrl"
                :id="designId"
                :result.sync="data.options.props.cascadeList"
                :config-options.sync="configInputOptions"
                :serviceArr.sync="initDependent.acServiceArr"
                :isflag.sync="initDependent.isCascader"
                width="100"
                :key="changeValue"
              ></api-input>
              <!-- 初始值的选框 -->
              <div style="margin-bottom: 5px"></div>
              <el-input
                size="mini"
                style=""
                v-model="data.options.props.paramFormat"
              >
                <template slot="prepend">参数格式</template>
              </el-input>
            </template>
            <template>
              <div class="sw-remote-api">
                <div class="sw-remote-label">标签</div>
                <template>
                  <template v-if="initDependent.isCascader">
                    <el-cascader
                      :key="keyValue"
                      v-model="data.options.props.cascaderVal"
                      :props="{ checkStrictly: true, expandTrigger: 'hover' }"
                      clearable
                      :options="data.options.props.cascadeList"
                      @change="handleChange"
                    >
                    </el-cascader>
                  </template>
                  <template v-if="!initDependent.isCascader">
                    <el-select
                      v-model="data.options.props.label"
                      placeholder="请选择标签对应字段"
                      filterable
                      clearable
                      @change="handleChangeSelect"
                    >
                      <template
                        v-for="(coo, index) in data.options.props.cascadeList"
                      >
                        <el-option
                          v-if="typeof coo == 'string'"
                          :key="index"
                          :label="coo"
                          :value="coo"
                        >
                        </el-option>
                      </template>
                    </el-select>
                  </template>
                </template>
              </div>
            </template>
          </div>
        </template>
      </el-form-item>

      <el-form-item
        label="控件配置"
        v-if="data.options.hasOwnProperty('carNumberOptions')"
      >
        <div class="car-number-form-item">
          <div class="item">
            <span class="label">主题</span>
            <div class="theme">
              <el-radio-group v-model="data.options.carNumberOptions.theme">
                <el-radio-button label="block">默认</el-radio-button>
                <el-radio-button label="line">线性</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="item">
            <span class="label">单个框宽度</span>
            <el-input-number
              v-model="data.options.carNumberOptions.boxWidth"
              controls-position="right"
            />
          </div>
          <div class="item">
            <span class="label">单个框高度</span>
            <el-input-number
              v-model="data.options.carNumberOptions.boxHeight"
              controls-position="right"
            />
          </div>
          <div class="item">
            <span class="label">单个框间隔</span>
            <el-input-number
              v-model="data.options.carNumberOptions.boxMargin"
              controls-position="right"
            />
          </div>
          <div class="item">
            <span class="label">圆角</span>
            <el-input
              style="width: 130px"
              placeholder="填写100px、50%"
              v-model="data.options.carNumberOptions.borderRadius"
            />
          </div>
          <div class="item">
            <span class="label">字体大小</span>
            <el-input-number
              v-model="data.options.carNumberOptions.textSize"
              controls-position="right"
            />
          </div>
          <div class="item">
            <span class="label">字体颜色</span>
            <el-input
              placeholder="请选择字体颜色"
              v-model="data.options.carNumberOptions.textColor"
              class="input-with-color"
            >
              <el-color-picker
                slot="append"
                size="mini"
                v-model="data.options.carNumberOptions.textColor"
              />
            </el-input>
          </div>
          <div class="item">
            <span class="label">字体框颜色</span>
            <el-input
              placeholder="请选择字体框颜色"
              v-model="data.options.carNumberOptions.borderColor"
              class="input-with-color"
            >
              <el-color-picker
                slot="append"
                size="mini"
                v-model="data.options.carNumberOptions.borderColor"
              />
            </el-input>
          </div>
          <div class="item">
            <span class="label">选中字体框颜色</span>
            <el-input
              placeholder="请选择选中字体框颜色"
              v-model="data.options.carNumberOptions.selectBorderColor"
              class="input-with-color"
            >
              <el-color-picker
                slot="append"
                size="mini"
                v-model="data.options.carNumberOptions.selectBorderColor"
              />
            </el-input>
          </div>
          <div class="item">
            <span class="label">背景颜色</span>
            <el-input
              placeholder="请选择背景颜色"
              v-model="data.options.carNumberOptions.backgroundColor"
              class="input-with-color"
            >
              <el-color-picker
                slot="append"
                size="mini"
                v-model="data.options.carNumberOptions.backgroundColor"
              />
            </el-input>
          </div>
          <div class="item">
            <span class="label">新能源的颜色</span>
            <el-input
              placeholder="请选择新能源的颜色"
              v-model="data.options.carNumberOptions.newEnergyColor"
              class="input-with-color"
            >
              <el-color-picker
                slot="append"
                size="mini"
                v-model="data.options.carNumberOptions.newEnergyColor"
              />
            </el-input>
          </div>
          <div class="item">
            <span class="label">新能源的字体大小</span>
            <el-input-number
              v-model="data.options.carNumberOptions.newEnergyFontSize"
              controls-position="right"
            />
          </div>
        </div>
      </el-form-item>

      <el-form-item
        label="默认值"
        v-if="
          Object.keys(data.options).indexOf('defaultValue') >= 0 &&
          (data.type === 'divider' ||
            data.type === 'textarea' ||
            data.type === 'input' ||
            data.type === 'rate' ||
            data.type === 'color' ||
            data.type === 'switch' ||
            data.type === 'swtext' ||
            data.type === 'slider' ||
            data.type === 'number')
        "
        :key="data.key"
      >
        <el-input
          v-if="data.type === 'textarea'"
          type="textarea"
          :rows="5"
          v-model="data.options.defaultValue"
        >
        </el-input>
        <template v-if="data.type === 'input'">
          <template v-if="data.options.hasOwnProperty('carNumberOptions')">
            <!-- <el-input
              v-if="data.type === 'input'"
              v-model="data.options.defaultValue"
              :type="data.options.dataType"
              maxlength="8"
              show-word-limit
            >
            </el-input> -->
          </template>
          <template v-else>
            <el-input
              v-if="data.type === 'input'"
              v-model="data.options.defaultValue"
              :type="data.options.dataType"
            >
            </el-input>
          </template>
        </template>

        <el-input-number
          v-if="data.type === 'slider' || data.type === 'number'"
          v-model="data.options.defaultValue"
          :step="1"
        ></el-input-number>
        <el-rate
          v-if="data.type === 'rate'"
          style="display: inline-block; vertical-align: middle"
          :max="data.options.max"
          :allow-half="data.options.allowHalf"
          v-model="data.options.defaultValue"
        ></el-rate>
        <el-button
          type="text"
          v-if="data.type === 'rate'"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-left: 10px;
          "
          @click="data.options.defaultValue = 0"
          >清空</el-button
        >
        <el-color-picker
          v-if="data.type === 'color'"
          v-model="data.options.defaultValue"
          :show-alpha="data.options.showAlpha"
        ></el-color-picker>
        <el-switch
          v-if="data.type === 'switch'"
          v-model="data.options.defaultValue"
        ></el-switch>
        <el-input
          v-if="data.type === 'divider'"
          v-model="data.options.defaultValue"
        ></el-input>
        <el-input
          v-if="data.type === 'swtext' && !data.options.isTextEditor"
          v-model="data.options.defaultValue"
        >
        </el-input>
        <fm-editor
          v-if="data.type === 'swtext' && data.options.isTextEditor"
          v-model="data.options.defaultValue"
        >
        </fm-editor>
      </el-form-item>

      <el-form-item
        label="默认值"
        v-if="
          Object.keys(data.options).indexOf('defaultValue') >= 0 &&
          data.type === 'hidden'
        "
      >
        <el-select
          v-model="data.options.dataForm"
          placeholder="请选择"
          @change="swElHiddenChange"
        >
          <el-option value="fixed" label="固定值" />
          <el-option value="random" label="随机值" />
          <el-option value="far" label="远端值" />
        </el-select>
        <el-input
          v-if="data.options.dataForm === 'fixed'"
          placeholder="请输入固定值"
          v-model="data.options.defaultValue"
        >
        </el-input>
        <el-select
          v-else-if="data.options.dataForm === 'random'"
          v-model="data.options.randomFunc"
          placeholder="请选择"
        >
          <el-option value="dateStr" label="时间戳" />
          <el-option value="uuidStr" label="UUID" />
        </el-select>
        <div v-if="data.options.dataForm === 'far'">
          <el-input size="mini" v-model="data.options.remoteUrl">
            <template slot="prepend">接口地址</template>
          </el-input>
          <el-input size="mini" v-model="data.options.remoteKey">
            <template slot="prepend">返回参数key</template>
          </el-input>
        </div>
      </el-form-item>

      <el-form-item label="默认高度" v-if="data.type === 'textarea'">
        <el-input-number
          v-model="data.options.defaultRows"
          :min="1"
          :max="10"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="草稿覆盖" v-if="data.options.draftOverrideVisible">
        <el-switch v-model="data.options.draftOverride" />
      </el-form-item>

      <el-form-item label="审批意见提示" v-if="data.type == 'textarea'">
        <el-switch v-model="data.options.approvalTipValue"> </el-switch>
      </el-form-item>
      <!-- 新增：常用审批语 -->
      <el-form-item label="常用审批语" v-if="data.type == 'textarea'">
        <template>
          <el-checkbox-group v-model="data.options.ApprovalLanguage">
            <ul>
              <li
                v-for="(item, index) in data.options.languageList"
                :key="index"
              >
                <el-checkbox :label="item.value" style="margin-right: 5px">
                  <el-input
                    :style="{
                      width: data.options.showLabel ? '90px' : '180px',
                    }"
                    size="mini"
                    :disabled="
                      data.options.ApprovalLanguage.includes(item.value)
                    "
                    v-model="item.value"
                  ></el-input>
                  <el-button
                    @click="handleLanguageListRemove(index)"
                    circle
                    plain
                    type="danger"
                    size="mini"
                    icon="el-icon-minus"
                    style="padding: 4px; margin-left: 5px"
                  ></el-button>
                </el-checkbox>
              </li>
            </ul>
          </el-checkbox-group>
        </template>
        <div style="margin-left: 22px">
          <el-button type="text" @click="handleLanguageListAdd"
            >添加选项</el-button
          >
        </div>
      </el-form-item>

      <el-form-item
        label="占位内容"
        v-if="
          Object.keys(data.options).indexOf('placeholder') >= 0 &&
          data.type !== 'time' &&
          data.type !== 'date'
        "
      >
        <el-input v-model="data.options.placeholder"></el-input>
      </el-form-item>
      <el-form-item
        label="宽度（百分比）"
        v-if="
          Object.keys(data.options).indexOf('width') >= 0 &&
          data.type !== 'report' &&
          data.type !== 'td'
        "
      >
        <el-input v-model="data.options.width"></el-input>
      </el-form-item>
      <el-form-item
        label="高度（像素）"
        v-if="
          Object.keys(data.options).indexOf('height') >= 0 &&
          data.type !== 'report' &&
          data.type !== 'td'
        "
      >
        <el-input v-model="data.options.height"></el-input>
      </el-form-item>
      <el-form-item
        label="大小"
        v-if="
          Object.keys(data.options).indexOf('size') >= 0 &&
          data.type !== 'button'
        "
      >
        宽度：<el-input
          style="width: 90px"
          type="number"
          v-model.number="data.options.size.width"
        ></el-input
        >像素<br />
        高度：<el-input
          style="width: 90px"
          type="number"
          v-model.number="data.options.size.height"
        ></el-input
        >像素
      </el-form-item>
      <el-form-item
        label="布局方式"
        v-if="Object.keys(data.options).indexOf('inline') >= 0"
      >
        <el-radio-group v-model="data.options.inline">
          <el-radio-button :label="false">块级</el-radio-button>
          <el-radio-button :label="true">行内</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="显示输入框"
        v-if="Object.keys(data.options).indexOf('showInput') >= 0"
      >
        <el-switch v-model="data.options.showInput"></el-switch>
      </el-form-item>
      <el-form-item
        label="最小值"
        v-if="Object.keys(data.options).indexOf('min') >= 0"
      >
        <el-input-number v-model="data.options.min" :step="1"></el-input-number>
      </el-form-item>
      <el-form-item
        label="最大值"
        v-if="Object.keys(data.options).indexOf('max') >= 0"
      >
        <el-input-number v-model="data.options.max" :step="1"></el-input-number>
      </el-form-item>
      <el-form-item
        label="步长"
        v-if="Object.keys(data.options).indexOf('step') >= 0"
      >
        <el-input-number v-model="data.options.step"></el-input-number><br />
        <el-radio-group v-model="data.options.stepStrictly">
          <el-radio-button :label="true">严格</el-radio-button>
          <el-radio-button :label="false">不严格</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="支持Excel导入" v-if="data.type === 'sonform'">
        <el-switch v-model="data.options.importExcel"></el-switch>
      </el-form-item>

      <el-form-item label="序号标题" v-if="data.type === 'sonform'">
        <el-input v-model="data.options.numberTitle"></el-input>
      </el-form-item>

      <el-form-item label="自定义新增按钮名称" v-if="data.type === 'sonform'">
        <el-input v-model="data.options.addBtnName"></el-input>
      </el-form-item>

      <el-form-item label="索引前缀" v-if="data.type === 'sonform'">
        <el-input v-model="data.options.prefix"></el-input>
      </el-form-item>

      <el-form-item label="索引后缀" v-if="data.type === 'sonform'">
        <el-input v-model="data.options.suffix"></el-input>
      </el-form-item>

      <el-form-item label="人员数据格式配置" v-if="data.type === 'user'">
        xm:姓名，gh:工号，bm:部门
        <el-input v-model="data.options.format"></el-input>
      </el-form-item>
      <el-form-item label="是否多选" v-if="data.type === 'user'">
        <el-switch v-model="data.options.multiple"></el-switch>
      </el-form-item>
      <el-form-item label="配置默认用户组" v-if="data.type === 'user'">
        <el-select
          popper-class="el-select-group"
          v-model="data.options.groupId"
          placeholder="请选择用户组"
          v-el-select-loadmore="loadmore"
          :teleported="false"
          :fit-input-width="true"
          filterable
          remote
          clearable
          no-data-text="暂无数据"
          :remote-method="remoteMethod"
          @focus="handleFocusChange"
          @clear="handleClear"
        >
          <el-option
            v-for="item in data.options.groupsOptions"
            :key="item.id"
            :value="item.id"
            :label="item.roleName"
          >
            <span
              style="
                width: 200px;
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >{{ item.roleName }}</span
            >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否使用组织机构选择" v-if="data.type === 'user'">
        <el-switch v-model="data.options.useOraganization"></el-switch>
      </el-form-item>
      <el-form-item
        label="配置默认组织机构id"
        v-if="
          (data.type === 'user' && data.options.useOraganization) ||
          data.type === 'organization'
        "
      >
        <el-input
          placeholder="默认为全部"
          v-model="data.options.orgRootId"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item
        label="配置默认用户组id"
        v-if="
          (data.type === 'user' && data.options.useOraganization) ||
          data.type === 'organization'
        "
      >
        <el-input
          placeholder="默认为全部"
          v-model="data.options.orgRootId"
        ></el-input>
      </el-form-item> -->
      <el-form-item
        label="支持Excel导入"
        v-if="data.type === 'user' && data.options.multiple"
      >
        <el-switch v-model="data.options.supportExcel"></el-switch>
      </el-form-item>

      <el-form-item label="Excel模板链接" v-if="data.options.supportExcel">
        <el-input v-model="data.options.templateLink"></el-input>
      </el-form-item>
      <el-form-item
        label="读取Excel工号字段名"
        v-if="
          data.type === 'user' &&
          data.options.multiple & data.options.supportExcel
        "
      >
        <el-input v-model="data.options.usernameKey"></el-input>
      </el-form-item>
      <el-form-item label="按键间隔时间（毫秒）" v-if="data.type === 'user'">
        <el-input v-model="data.options.timeInterval"></el-input>
      </el-form-item>
      <el-form-item
        label="移动端是否初始化人员选择接口数据"
        v-if="data.type === 'user'"
      >
        <el-switch v-model="data.options.supportMobileInit"></el-switch>
      </el-form-item>
      <el-form-item label="身份Id" v-if="data.type === 'user'">
        <el-input
          v-model="data.options.identityTypeIds"
          placeholder="请输入身份Id"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="是否多选"
        v-if="
          data.type === 'select' ||
          data.type === 'imgupload' ||
          data.type === 'file' ||
          data.type === 'cascader' ||
          data.type === 'organization'
        "
      >
        <el-switch
          v-model="data.options.multiple"
          @change="handleSelectMuliple"
        ></el-switch>
      </el-form-item>
      <el-form-item
        label="是否可选任一层级"
        v-if="
          data.type === 'address' ||
          data.type === 'cascader' ||
          data.type === 'organization'
        "
      >
        <el-switch v-model="data.options.checkStrictly"></el-switch>
      </el-form-item>
      <el-form-item
        label="是否显示路径"
        v-if="data.type === 'organization' || data.type === 'cascader'"
      >
        <el-switch v-model="data.options.showAllLevels"></el-switch>
      </el-form-item>
      <el-form-item label="是否可搜索" v-if="data.type === 'select'">
        <el-switch v-model="data.options.filterable"></el-switch>
      </el-form-item>
      <el-form-item
        label="允许半选"
        v-if="Object.keys(data.options).indexOf('allowHalf') >= 0"
      >
        <el-switch v-model="data.options.allowHalf"></el-switch>
      </el-form-item>
      <el-form-item
        label="方向"
        v-if="
          Object.keys(data.options).indexOf('directionValue') >= 0 &&
          !data.options.isTextEditor
        "
      >
        <el-select v-model="data.options.directionValue" placeholder="请选择">
          <el-option value="horizontal" label="横向" />
          <el-option value="vertical" label="竖向" />
        </el-select>
      </el-form-item>
      <el-form-item
        label="是否显示线条"
        v-if="data.type === 'divider' && !data.options.isTextEditor"
      >
        <el-radio-group v-model="data.options.showLine">
          <el-radio-button :label="true">显示</el-radio-button>
          <el-radio-button :label="false">不显示</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="位置"
        v-if="
          Object.keys(data.options).indexOf('contentPositionValue') >= 0 &&
          data.options.showLine &&
          data.options.directionValue === 'horizontal'
        "
      >
        <el-select
          v-model="data.options.contentPositionValue"
          placeholder="请选择"
        >
          <el-option value="center" label="中间" />
          <el-option value="left" label="左边" />
          <el-option value="right" label="右边" />
        </el-select>
      </el-form-item>
      <el-form-item
        label="支持透明度选择"
        v-if="Object.keys(data.options).indexOf('showAlpha') >= 0"
      >
        <el-switch v-model="data.options.showAlpha"></el-switch>
      </el-form-item>
      <el-form-item
        label="是否显示标签"
        v-if="Object.keys(data.options).indexOf('showLabel') >= 0"
      >
        <el-switch v-model="data.options.showLabel"></el-switch>
      </el-form-item>
      <el-form-item
        label="子表单导入是否选择导入标签"
        v-if="
          Object.keys(data.options).indexOf('showLabel') >= 0 &&
          data.options.showLabel &&
          data.options.isSon
        "
      >
        <el-switch v-model="data.options.excelImportLabel"></el-switch>
      </el-form-item>
      <el-form-item
        label="选项"
        v-if="Object.keys(data.options).indexOf('options') >= 0"
      >
        <el-radio-group
          v-model="data.options.optionType"
          @change="switchOptionType"
          size="mini"
          style="margin-bottom: 10px"
        >
          <el-radio-button label="static">静态数据</el-radio-button>
          <el-radio-button label="dictionary">数据字典</el-radio-button>
          <el-radio-button label="service">远端接口</el-radio-button>
        </el-radio-group>
        <template v-if="data.options.optionType === 'service'">
          <div>
            <api-select
              :sel-value.sync="data.options.remoteUrl"
              :id="designId"
              :result.sync="data.options.props.cascadeFields"
              :config-options.sync="configOptions"
              width="100"
            >
            </api-select>
            <div style="margin-bottom: 5px"></div>
            <el-input
              size="mini"
              style=""
              v-model="data.options.props.paramFormat"
            >
              <template slot="prepend">参数格式</template>
            </el-input>
            <div class="sw-remote-api">
              <div class="sw-remote-label">值</div>
              <el-select
                v-model="data.options.props.value"
                placeholder="请选择值对应字段"
                filterable
                clearable
              >
                <el-option
                  v-for="coo in data.options.props.cascadeFields"
                  :key="coo"
                  :label="coo"
                  :value="coo"
                >
                </el-option>
              </el-select>
            </div>
            <div class="sw-remote-api">
              <div class="sw-remote-label">标签</div>
              <el-select
                v-model="data.options.props.label"
                placeholder="请选择标签对应字段"
                filterable
                clearable
              >
                <el-option
                  v-for="coo in data.options.props.cascadeFields"
                  :key="coo"
                  :label="coo"
                  :value="coo"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </template>
        <template v-else-if="data.options.optionType === 'dictionary'">
          <dic-type-select
            :dic-type="dicType"
            v-model="data.options.dicTypeCode"
          ></dic-type-select>
        </template>
        <template v-else>
          <template
            v-if="
              data.type === 'radio' ||
              (data.type === 'select' && !data.options.multiple)
            "
          >
            <el-radio-group v-model="data.options.defaultValue">
              <draggable
                tag="ul"
                :list="data.options.options"
                v-bind="{
                  group: { name: 'options' },
                  ghostClass: 'ghost',
                  handle: '.drag-item',
                }"
                handle=".drag-item"
              >
                <li v-for="(item, index) in data.options.options" :key="index">
                  <el-radio :label="item.value" style="margin-right: 5px">
                    <el-input
                      :style="{
                        width: data.options.showLabel ? '90px' : '180px',
                      }"
                      size="mini"
                      v-model="item.value"
                    ></el-input>
                    <el-input
                      style="width: 100px"
                      size="mini"
                      v-if="data.options.showLabel"
                      v-model="item.label"
                    >
                    </el-input>
                    <!-- <input v-model="item.value"/> -->
                  </el-radio>
                  <i
                    class="drag-item"
                    style="font-size: 16px; margin: 0 5px; cursor: move"
                    ><i class="iconfont icon-icon_bars"></i
                  ></i>
                  <el-button
                    @click="handleOptionsRemove(index)"
                    circle
                    plain
                    type="danger"
                    size="mini"
                    icon="el-icon-minus"
                    style="padding: 4px; margin-left: 5px"
                  ></el-button>
                </li>
              </draggable>
            </el-radio-group>
          </template>

          <template
            v-if="
              data.type === 'checkbox' ||
              (data.type === 'select' && data.options.multiple)
            "
          >
            <el-checkbox-group v-model="data.options.defaultValue">
              <draggable
                tag="ul"
                :list="data.options.options"
                v-bind="{
                  group: { name: 'options' },
                  ghostClass: 'ghost',
                  handle: '.drag-item',
                }"
                handle=".drag-item"
              >
                <li v-for="(item, index) in data.options.options" :key="index">
                  <el-checkbox :label="item.value" style="margin-right: 5px">
                    <el-input
                      :style="{
                        width: data.options.showLabel ? '90px' : '180px',
                      }"
                      size="mini"
                      v-model="item.value"
                    ></el-input>
                    <el-input
                      style="width: 100px"
                      size="mini"
                      v-if="data.options.showLabel"
                      v-model="item.label"
                    >
                    </el-input>
                  </el-checkbox>
                  <i
                    class="drag-item"
                    style="font-size: 16px; margin: 0 5px; cursor: move"
                    ><i class="iconfont icon-icon_bars"></i
                  ></i>
                  <el-button
                    @click="handleOptionsRemove(index)"
                    circle
                    plain
                    type="danger"
                    size="mini"
                    icon="el-icon-minus"
                    style="padding: 4px; margin-left: 5px"
                  ></el-button>
                </li>
              </draggable>
            </el-checkbox-group>
          </template>
          <div style="margin-left: 22px">
            <el-button type="text" @click="handleAddOption">添加选项</el-button>
          </div>
        </template>
      </el-form-item>
      <el-form-item
        label="当前默认值"
        v-if="
          Object.keys(data.options).indexOf('options') >= 0 &&
          data.type !== 'checkbox'
        "
      >
        <el-input
          v-model="data.options.defaultValue"
          placeholder="请输入内容"
        ></el-input>
        <el-button type="text" @click="handleClearDefault">清除默认</el-button>
      </el-form-item>
      <el-form-item
        label="缓存数据"
        v-if="data.options.hasOwnProperty('remoteOptionsCache')"
      >
        <el-switch v-model="data.options.remoteOptionsCache"> </el-switch>
      </el-form-item>
      <el-form-item
        label="接口携带节点用户学工号"
        v-if="data.type === 'cascader'"
      >
        <el-checkbox v-model="data.options.remoteQuery.username"
          >学工号</el-checkbox
        >
      </el-form-item>
      <el-form-item label="接口携带控件值" v-if="data.type === 'cascader'">
        <el-input
          size="mini"
          style=""
          v-model="data.options.remoteQuery.fromWidget.key"
        >
          <template slot="prepend">控件字段名</template>
        </el-input>
      </el-form-item>
      <el-form-item label="远端数据" v-if="data.type === 'cascader'">
        <div>
          <el-input size="mini" style="" v-model="data.options.remoteUrl">
            <template slot="prepend">接口地址</template>
          </el-input>
          <el-input
            size="mini"
            style=""
            v-model="data.options.props.paramFormat"
          >
            <template slot="prepend">返回参数格式</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.value">
            <template slot="prepend">值</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.label">
            <template slot="prepend">标签</template>
          </el-input>
          <!--<el-input size="mini" style="" v-model="data.options.props.children">
            <template slot="prepend">子选项</template>
          </el-input>-->
          <el-input size="mini" style="" v-model="data.options.props.pk">
            <template slot="prepend">主键</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.ppk">
            <template slot="prepend">父主键</template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="远端数据" v-if="data.type === 'table'">
        <div>
          <api-select
            :config-variables.sync="data.options.variables"
            :sel-value.sync="data.options.remoteUrl"
            :id="designId"
            :result.sync="data.options.props.tableFields"
            :config-options.sync="configOptions"
            width="100"
          ></api-select>
          <div style="margin-bottom: 5px"></div>
          分页字段
          <el-input size="mini" style="" v-model="data.options.props.page">
            <template slot="prepend">页码字段</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.pageSize">
            <template slot="prepend">每页条数字段</template>
          </el-input>
          数据展示字段
          <el-input
            size="mini"
            style=""
            v-model="data.options.props.paramFormat"
          >
            <template slot="prepend">参数格式</template>
          </el-input>
          <!-- <el-input size="mini" style="" v-model="data.options.props.totalPage">
              <template slot="prepend">总页数字段</template>
            </el-input> -->
          <el-input
            size="mini"
            style=""
            v-model="data.options.props.tableTitle"
          >
            <template slot="prepend">表头字段</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.tableData">
            <template slot="prepend">表格数据字段</template>
          </el-input>
          <el-input size="mini" style="" v-model="data.options.props.total">
            <template slot="prepend">总条数字段</template>
          </el-input>
        </div>
      </el-form-item>

      <template v-if="data.type === 'time' || data.type === 'date'">
        <el-form-item label="显示类型" v-if="data.type === 'date'">
          <el-select v-model="data.options.type">
            <!-- <el-option value="year"></el-option> -->
            <el-option value="month"></el-option>
            <!-- <el-option value="date"></el-option> -->
            <!-- <el-option value="dates"></el-option>
            <el-option value="week"></el-option> -->
            <el-option value="datetime"></el-option>
            <el-option value="datetimerange"></el-option>
            <el-option value="daterange"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否为范围选择" v-if="data.type === 'time'">
          <el-switch v-model="data.options.isRange"></el-switch>
        </el-form-item>
        <el-form-item label="是否获取时间戳" v-if="data.type === 'date'">
          <el-switch v-model="data.options.timestamp"></el-switch>
        </el-form-item>
        <el-form-item
          label="占位内容"
          v-if="
            (!data.options.isRange && data.type === 'time') ||
            (data.type !== 'time' &&
              data.options.type !== 'datetimerange' &&
              data.options.type !== 'daterange')
          "
        >
          <el-input v-model="data.options.placeholder"></el-input>
        </el-form-item>
        <el-form-item
          label="开始时间占位内容"
          v-if="
            data.options.isRange ||
            data.options.type === 'datetimerange' ||
            data.options.type === 'daterange'
          "
        >
          <el-input v-model="data.options.startPlaceholder"></el-input>
        </el-form-item>
        <el-form-item
          label="结束时间占位内容"
          v-if="
            data.options.isRange ||
            data.options.type === 'datetimerange' ||
            data.options.type === 'daterange'
          "
        >
          <el-input v-model="data.options.endPlaceholder"></el-input>
        </el-form-item>
        <el-form-item label="格式">
          <el-input v-model="data.options.format"></el-input>
        </el-form-item>
        <el-form-item v-if="data.type === 'date'" label="日期选择范围">
          <el-date-picker
            v-model="data.options.startDate"
            :type="
              data.options.type === 'date' || data.options.type === 'daterange'
                ? 'date'
                : data.options.type === 'month'
                  ? 'month'
                  : data.options.type === 'datetime' ||
                      data.options.type === 'datetimerange'
                    ? 'datetime'
                    : ''
            "
            :value-format="
              data.options.timestamp ? 'timestamp' : data.options.format
            "
            :format="data.options.timestamp ? 'timestamp' : data.options.format"
            placeholder="可选最早日期"
            style="width: 100%"
          />
          <el-date-picker
            v-model="data.options.endDate"
            :type="
              data.options.type === 'date' || data.options.type === 'daterange'
                ? 'date'
                : data.options.type === 'month'
                  ? 'month'
                  : data.options.type === 'datetime' ||
                      data.options.type === 'datetimerange'
                    ? 'datetime'
                    : ''
            "
            :value-format="
              data.options.timestamp ? 'timestamp' : data.options.format
            "
            :format="data.options.timestamp ? 'timestamp' : data.options.format"
            placeholder="可选最晚日期"
            style="margin-top: 10px; width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="data.type === 'time'" label="时间选择范围">
          <el-time-picker
            v-model="data.options.startTime"
            placeholder="可选最早时间"
            value-format="HH:mm:ss"
            style="width: 100%"
          />
          <el-time-picker
            v-model="data.options.endTime"
            placeholder="可选最晚时间"
            value-format="HH:mm:ss"
            style="margin-top: 10px; width: 100%"
          />
        </el-form-item>
        <el-form-item
          label="默认值"
          v-if="
            data.type === 'time' &&
            Object.keys(data.options).indexOf('isRange') >= 0
          "
        >
          <el-time-picker
            key="1"
            style="width: 100%"
            v-if="!data.options.isRange"
            v-model="data.options.defaultValue"
            :arrowControl="data.options.arrowControl"
            :value-format="data.options.format"
          >
          </el-time-picker>
          <el-time-picker
            key="2"
            v-if="data.options.isRange"
            style="width: 100%"
            v-model="data.options.defaultValue"
            is-range
            :arrowControl="data.options.arrowControl"
            :value-format="data.options.format"
          >
          </el-time-picker>
        </el-form-item>
      </template>

      <el-form-item v-if="data.type === 'file'" label="文件上传展示形式">
        <el-select
          v-model="data.options.showType"
          placeholder="请选择文件上传展示形式"
        >
          <el-option value="drag" label="拖拽框形式" />
          <el-option value="btn" label="按钮形式" />
        </el-select>
      </el-form-item>

      <template v-if="data.type === 'imgupload' || data.type === 'file'">
        <el-form-item label="最大上传数">
          <el-input
            type="number"
            v-model.number="data.options.length"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传大小限制">
          <el-input type="number" v-model.number="data.options.maxSize">
            <template slot="append">Mb</template>
          </el-input>
        </el-form-item>
        <template>
          <el-form-item label="允许上传类型(多个英文逗号分隔)">
            <el-input v-model="data.options.allowableType"></el-input>
          </el-form-item>
          <!--<el-form-item label="上传地址" :required="true">
            <el-input v-model="data.options.action"></el-input>
          </el-form-item>-->
        </template>
      </template>

      <el-form-item
        v-if="data.type === 'file'"
        label="文件下载类型 （水印下载仅支持pdf文件）"
      >
        <el-select
          v-model="data.options.downloadType"
          placeholder="请选择文件下载类型"
        >
          <el-option value="ordinaryType" label="普通下载" />
          <el-option value="allType" label="普通下载和水印下载" />
          <el-option value="watermarkType" label="水印下载" />
        </el-select>
      </el-form-item>

      <template v-if="data.type === 'grid'">
        <el-form-item label="栅格间隔">
          <el-input
            type="number"
            v-model.number="data.options.gutter"
          ></el-input>
        </el-form-item>
        <el-form-item label="列配置项">
          <draggable
            tag="ul"
            :list="data.columns"
            v-bind="{
              group: { name: 'options' },
              ghostClass: 'ghost',
              handle: '.drag-item',
            }"
            handle=".drag-item"
          >
            <li v-for="(item, index) in data.columns" :key="index">
              <i
                class="drag-item"
                style="font-size: 16px; margin: 0 5px; cursor: move"
                ><i class="iconfont icon-icon_bars"></i
              ></i>
              <el-input
                placeholder="栅格值"
                size="mini"
                style="width: 100px"
                type="number"
                v-model.number="item.span"
              >
              </el-input>
              <el-button
                @click="handleOptionsRemove(index)"
                circle
                plain
                type="danger"
                size="mini"
                icon="el-icon-minus"
                style="padding: 4px; margin-left: 5px"
              ></el-button>
            </li>
          </draggable>
          <div style="margin-left: 22px">
            <el-button type="text" @click="handleAddColumn">添加列</el-button>
          </div>
        </el-form-item>
        <el-form-item label="水平排列方式">
          <el-select v-model="data.options.justify">
            <el-option value="start" label="左对齐"></el-option>
            <el-option value="end" label="右对齐"></el-option>
            <el-option value="center" label="居中"></el-option>
            <el-option value="space-around" label="两侧间隔相等"></el-option>
            <el-option value="space-between" label="两端对齐"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="垂直排列方式">
          <el-select v-model="data.options.align">
            <el-option value="top" label="顶部对齐"></el-option>
            <el-option value="middle" label="居中"></el-option>
            <el-option value="bottom" label="底部对齐"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="data.type === 'comment'">
        <el-form-item label="标题">
          <el-input v-model="data.name"></el-input>
        </el-form-item>
        <el-form-item label="字段（只读）">
          <el-input v-model="data.model" readonly></el-input>
        </el-form-item>
        <el-form-item label="评阅时显示他人评阅内容">
          <el-switch v-model="data.options.showOthersComment"></el-switch>
        </el-form-item>
        <el-form-item label="组件限制">
          <li
            style="margin-left: 10px; list-style-type: none"
            v-for="(item, index) in commentLimit"
            :key="index"
          >
            <a>
              <i
                v-if="item.icon.indexOf('sw-icon') === 0"
                class="icon"
                :class="item.icon"
              ></i>
              <i v-else class="icon iconfont" :class="item.icon"></i>
              <span style="margin-left: 10px">{{ item.name }}</span>
            </a>
          </li>
        </el-form-item>
      </template>
      <el-form-item
        label="最小列宽度"
        v-if="data.options.hasOwnProperty('minWidth')"
      >
        <el-input v-model="data.options.minWidth"></el-input>
      </el-form-item>
      <el-form-item
        label="最小行数"
        v-if="data.options.hasOwnProperty('minLines')"
      >
        <el-input-number v-model="data.options.minLines"></el-input-number>
      </el-form-item>
      <el-form-item
        label="最大行数"
        v-if="data.options.hasOwnProperty('maxLines')"
      >
        <el-input-number v-model="data.options.maxLines"></el-input-number>
      </el-form-item>

      <template v-if="data.type === 'sonform'">
        <el-form-item label="字段排序" v-if="data.list.length">
          <draggable
            tag="ul"
            :list="data.list"
            v-bind="{
              group: { name: 'options' },
              ghostClass: 'ghost',
              handle: '.drag-item',
            }"
            handle=".drag-item"
          >
            <li v-for="(item, index) in data.list" :key="index">
              <i
                class="drag-item"
                style="font-size: 16px; margin: 0 5px; cursor: move"
                ><i class="iconfont icon-icon_bars"></i
              ></i>
              {{ item.name }}
              列宽：<el-input
                v-model="item.colWidth"
                style="width: 100px"
              ></el-input>
              <el-button
                @click="handleOptionsRemove(index)"
                circle
                plain
                type="danger"
                size="mini"
                icon="el-icon-minus"
                style="padding: 4px; margin-left: 5px"
              ></el-button>
            </li>
          </draggable>
        </el-form-item>
        <el-form-item label="依赖同一控件列表">
          <el-switch v-model="data.options.useBaseList"></el-switch>
          <sw-tip type="warning" style="margin-top: 10px">
            <div slot="text">
              注意：当子表单需要每行使用不同的控件选项时需关闭，关闭后会降低渲染速度（例:第一行的下拉框与第二行的下拉框使用不同的选项列表）
            </div>
          </sw-tip>
        </el-form-item>
      </template>

      <!-- 按钮配置 -->
      <template v-if="data.type === 'button'">
        <!--<el-form-item label="图标"></el-form-item>-->
        <el-form-item label="类型">
          <el-select v-model="data.options.type">
            <el-option value="primary" label="primary"></el-option>
            <el-option value="success" label="success"></el-option>
            <el-option value="warning" label="warning"></el-option>
            <el-option value="danger" label="danger"></el-option>
            <el-option value="info" label="info"></el-option>
            <el-option value="text" label="text"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="大小">
          <el-select v-model="data.options.size">
            <el-option value="medium" label="中等按钮"></el-option>
            <el-option value="small" label="小型按钮"></el-option>
            <el-option value="mini" label="超小按钮"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="样式">
          <el-select v-model="data.options.clazz">
            <el-option value="" label="默认"></el-option>
            <el-option value="round" label="圆角"></el-option>
            <el-option value="circle" label="圆形"></el-option>
          </el-select>
        </el-form-item>
      </template>

      <!--<el-form-item label="自定义Class" v-if="data.options.hasOwnProperty('customClass')">
        <el-input v-model="data.options.customClass" clearable></el-input>
      </el-form-item>-->

      <el-form-item
        label="字段描述"
        v-if="data.options.hasOwnProperty('customDesc')"
      >
        <el-input type="textarea" v-model="data.options.customDesc"></el-input>
      </el-form-item>
      <template v-if="data.type == 'report'">
        <el-form-item :label="'表格边框宽度'">
          <el-input-number
            v-model="data.options.borderWidth"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item :label="'表格边框颜色'">
          <el-color-picker v-model="data.options.borderColor"></el-color-picker>
        </el-form-item>
      </template>
      <template v-if="data.type == 'td'">
        <el-form-item label="宽度（像素）">
          <el-input v-model="data.options.width"></el-input>
        </el-form-item>
        <el-form-item label="高度（像素）">
          <el-input v-model="data.options.height"></el-input>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import FmEditor from './Editor/index'
import { sonFormSel } from './advanced/sonfrom/sonFormSel'
import widgetConfigUtils from '../util/widgetConfigUtils'
import alertUtils from '../util/alertUtils'
import formUtils from '../util/formUtils'
import DicTypeSelect from './advanced/dicTypeSelect'
import ApiSelect from './advanced/custom/index'
import ApiInput from './advanced/custom/inputindex'
import { getShowRoleList } from '@/api/index'
export default {
  name: 'widget-config',
  components: {
    Draggable,
    FmEditor,
    DicTypeSelect,
    ApiSelect,
    ApiInput,
  },
  props: ['designId', 'data', 'tableList', 'formInfo', 'sonPages'],
  directives: {
    'el-select-loadmore': {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )

        SELECTWRAP_DOM.addEventListener('scroll', function () {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      },
    },
  },
  data() {
    return {
      sonFormSel,
      tableOptions: [],
      sonTableOptions: [],
      tableFieldSel: [],
      pageFields: [], // 子页面包括的组件
      dicType: {
        // 字典类型列表
        id: '',
        list: [],
        page: 1,
        limit: 20,
        isEnd: false, // 是否已查询所有数据
        name: '', // 查询参数
        loading: false, // 是否查询完成
      },
      tableFiledInfo: new Map(),
      validator: {
        type: null,
        required: null,
        pattern: null,
        range: null,
        length: null,
      },
      configOptions: [], // 远程接口列表select
      commentLimit: [
        {
          name: '单行文本',
          icon: 'icon-input',
        },
        {
          name: '多行文本',
          icon: 'icon-diy-com-textarea',
        },
        {
          name: '时间选择器',
          icon: 'icon-time',
        },
        {
          name: '日期选择器',
          icon: 'icon-date',
        },
        {
          name: '栅格组件',
          icon: 'icon-grid-',
        },
      ],
      // （以下是）初始化选框的相关配置
      configInputOptions: [], // 远程接口列表input
      keyValue: 0, // 控制级联选择器组件刷新
      changeValue: 0, // 控制apiInput组件刷新
      initDependent: {
        acServiceArr: [], // 接口返回的数据列表(且数据不重复)
        isCascader: true,
      },
      // 常用审批提示语
      languageListLength: null,
      currentModel: '',
      groupsPageSize: 10,
      groupsPageIndex: 1,
      groupsPageCount: 1,
      groupsSearch: '',
    }
  },
  created() {
    if (this.data.options.optionType === 'dictionary' && this.formInfo.id) {
      if (
        (this.dicType.list === null || this.dicType.list.length <= 0) &&
        this.dicType.page === 1
      ) {
        // 如果字典类型 list 为空 则 查询一次
        this.dicType.id = this.formInfo.id
        widgetConfigUtils.queryDicTypeList(this.dicType)
      }
    }
    if (
      typeof this.formInfo.id !== 'undefined' &&
      this.formInfo.id &&
      Object.keys(this.data.options).indexOf('appId') >= 0 &&
      !this.data.options.appId
    ) {
      this.data.options.appId = this.formInfo.id
    }
    this.handleGetShowRoleList()
  },
  computed: {
    pageFieldsComputed() {
      const tempFields = this.pageFields.filter(field => {
        return field.type !== 'page' && !field.isSon
      })
      return tempFields
    },
    show() {
      if (this.data && Object.keys(this.data).length > 0) {
        return true
      }
      return false
    },
    sonFormDataModel: {
      get() {
        if (this.data.model) {
          const arr = this.data.model.split(`_${this.data.key}`)
          if (arr.length > 0) {
            const value = arr[0]
            if (value.includes('page_')) {
              return value.split('page_')[1]
            }
            if (value.includes('sonform_colorful_egg_')) {
              return value.split('sonform_colorful_egg_')[1]
            }
            if (value.includes('page')) {
              return value.split('page')[1]
            }
            if (value.includes('sonform_colorful_egg')) {
              return value.split('sonform_colorful_egg')[1]
            }
          }
        }
        return ''
      },
      set(val) {
        const type =
          this.data.type === 'page'
            ? val
              ? 'page_'
              : 'page'
            : val
              ? 'sonform_colorful_egg_'
              : 'sonform_colorful_egg'
        this.data.model = `${type}${val}_${this.data.key}`
      },
    },
  },
  methods: {
    handleTableInfos() {
      // 处理数据库表，字段信息
      if (this.tableList) {
        const mainTable = this.tableList.mainTable // 主表  对象
        if (!mainTable) {
          alertUtils.alertError('没有主表信息', true)
          return
        }
        this.tableOptions = []
        this.setTableInfo(mainTable, 'main')
        const slaveTable = this.tableList.slaveTable // 从表  数组
        for (const lop in slaveTable) {
          this.setTableInfo(slaveTable[lop], 'slave')
        }
        const subTable = this.tableList.subTable // 子表  数组
        for (const lop in subTable) {
          this.setTableInfo(subTable[lop], 'sub')
        }
      } else {
        alertUtils.alertError('未获取到数据库结构信息！！！', true)
      }
    },
    setTableInfo(table, type) {
      if (table && type) {
        const tableInfo = {
          value: table.tname,
          label: table.tcomment,
          type: type,
          children: [],
        }
        for (const loop in table.fieldList) {
          const field = {
            value: table.fieldList[loop].name,
            label: table.fieldList[loop].comment,
            type: type,
            fieldInfo: table.fieldList[loop],
          }
          tableInfo.children.push(field)
          const names = table.tname + ',' + table.fieldList[loop].name
          this.tableFiledInfo.set(names, field.fieldInfo)
        }
        if (type === 'sub') {
          this.sonTableOptions.push(tableInfo)
        } else {
          this.tableOptions.push(tableInfo)
        }
      }
    },
    changeTableFieldSel(data) {
      if (data && data.length > 0) {
        this.data.model = this.tableFieldSel.join(',')
        const fieldInfos = this.tableFiledInfo.get(this.data.model)
        this.data.name = fieldInfos.comment
        this.data.options.required = fieldInfos.notnull === 'true'
        this.data.options.defaultValue = fieldInfos.t_default
      } else {
        this.data.model = ''
      }
    },
    switchOptionType() {
      // 选项 切换， 重置  remoteOption
      this.data.options.remoteOptions = []
    },
    selectPageValue() {
      // 选择页面后切换页面组件标题
      this.data.options.showField = []
      if (
        this.data.options.selectPage &&
        this.sonPages &&
        this.sonPages[this.data.options.selectPage]
      ) {
        this.data.name = this.sonPages[this.data.options.selectPage].title
        this.pageFields = formUtils.getComponentsListInfo(
          this.sonPages[this.data.options.selectPage].list
        )
      } else {
        this.data.name = '页面组件'
        this.pageFields = []
      }
    },
    handleOptionsRemove(index) {
      if (this.data.type === 'grid') {
        this.data.columns.splice(index, 1)
      } else if (this.data.type === 'sonform') {
        this.data.list.splice(index, 1)
      } else {
        this.data.options.options.splice(index, 1)
      }
    },
    handleAddOption() {
      if (this.data.options.showLabel) {
        this.data.options.options.push({
          value: '新选项',
          label: '新选项',
        })
      } else {
        this.data.options.options.push({
          value: '新选项',
        })
      }
    },
    // 常用审批语
    handleLanguageListRemove(index) {
      if (this.data.type === 'textarea') {
        const kValue = this.data.options.languageList[index].value

        if (this.data.options.languageList.length <= 2) {
          alertUtils.alertWarning('应至少保留2条审批提示语', true)
          return
        }
        if (
          this.data.options.ApprovalLanguage &&
          this.data.options.ApprovalLanguage.length
        ) {
          this.data.options.ApprovalLanguage.forEach((item, elIndex) => {
            if (item === kValue) {
              this.data.options.ApprovalLanguage.splice(elIndex, 1)
            }
          })
          this.data.options.languageList.splice(index, 1)
        } else {
          this.data.options.languageList.splice(index, 1)
        }
      }
    },
    handleLanguageListAdd() {
      if (this.data.type === 'textarea') {
        if (this.data.options.showLabel) {
          this.data.options.languageList.push({
            value: '新选项',
            label:
              '新选项' +
              (this.data.options.languageList[this.languageListLength - 1].key +
                1),
            key:
              this.data.options.languageList[this.languageListLength - 1].key +
              1,
          })
        } else {
          this.data.options.languageList.push({
            value:
              '新选项' +
              (this.data.options.languageList[this.languageListLength - 1].key +
                1),
            key:
              this.data.options.languageList[this.languageListLength - 1].key +
              1,
          })
        }
      }
    },
    handleClearDefault() {
      if (
        this.data.type === 'radio' ||
        (this.data.type === 'select' && !this.data.options.multiple)
      ) {
        this.data.options.defaultValue = ''
      } else {
        this.data.options.defaultValue = []
      }
    },
    handleAddColumn() {
      this.data.columns.push({
        span: '',
        list: [],
      })
    },
    generateRule() {
      this.data.rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) {
          this.data.rules.push(this.validator[key])
        }
      })
    },
    handleSelectMuliple(value) {
      if (value) {
        if (this.data.options.defaultValue) {
          this.data.options.defaultValue = [...this.data.options.defaultValue]
        } else {
          this.data.options.defaultValue = []
        }
      } else {
        if (this.data.options.defaultValue.length > 0) {
          this.data.options.defaultValue = this.data.options.defaultValue[0]
        } else {
          this.data.options.defaultValue = ''
        }
      }
    },
    validateRequired(val) {
      if (val) {
        this.validator.required = {
          required: true,
          message: `${this.data.name}必须填写`,
        }
      } else {
        this.validator.required = null
      }
      this.$nextTick(() => {
        this.generateRule()
      })
    },
    validateDataType(val) {
      if (!this.show) {
        return false
      }
      if (val) {
        this.validator.type = {
          type: val,
          message: this.data.name + '格式不正确',
        }
      } else {
        this.validator.type = null
      }
      this.generateRule()
    },
    valiatePattern(val) {
      if (!this.show) {
        return false
      }
      if (val) {
        this.validator.pattern = {
          pattern: val,
          message: this.data.name + '格式不匹配',
        }
      } else {
        this.validator.pattern = null
      }
      this.generateRule()
    },
    handleChangeValue() {
      if (this.data.type === 'divider') {
        if (this.data.options.isTextEditor) {
          this.data.options.showLine = false
        } else {
          this.data.options.showLine = true
        }
        return
      }
      this.data.options.defaultValue = ''
    },
    swElHiddenChange() {
      this.data.options.defaultValue = null
      this.data.options.randomFunc = ''
      this.data.options.remoteUrl = ''
      this.data.options.remoteKey = ''
    },
    dataTypeChange() {
      if (this.data.options.dataType) {
        if (
          this.data.options.dataType === 'number' ||
          this.data.options.dataType === 'integer' ||
          this.data.options.dataType === 'float'
        ) {
          this.data.options.defaultValue = 0
        } else {
          this.data.options.defaultValue = ''
        }
      }
    },
    handleChange() {},
    handleChangeSelect() {
      // console.log("data.options.props.label",val);
    },
    // 人员组件-用户组下拉模糊查询
    async handleGetShowRoleList(flag) {
      try {
        const params = {
          page: this.groupsPageIndex,
          limit: this.groupsPageSize,
          roleName: this.groupsSearch,
        }
        const res = await getShowRoleList(params)
        const { data, count } = res
        if (data && data.length > 0) {
          if (flag) {
            // 是否拼接数据
            this.data.options.groupsOptions =
              this.data.options.groupsOptions.concat(data)
          } else {
            this.data.options.groupsOptions = data
          }

          this.groupsPageCount = Math.ceil(count / this.groupsPageSize)
        }
      } catch (error) {
        console.log(error)
      } finally {
        //
      }
    },
    remoteMethod(query) {
      if (query) {
        this.data.options.groupsOptions = []
        this.groupsSearch = query
        this.groupsPageIndex = 1
        this.groupsPageSize = 10
        this.handleGetShowRoleList()
      } else {
        this.data.options.groupsOptions = []
      }
    },
    loadmore() {
      this.groupsPageIndex++
      if (this.groupsPageIndex > this.groupsPageCount) {
        return
      }
      this.handleGetShowRoleList(true)
    },
    /**
     * 光标触发下拉框时 如果下拉框数据为空 则请求第一页数据
     */
    handleFocusChange() {
      if (!this.data.options.groupsOptions) {
        this.data.options = {
          ...this.data.options,
          groupsOptions: [],
        }
      }
      if (this.data.options.groupsOptions.join() === '') {
        this.data.options = {
          ...this.data.options,
          groupsOptions: [],
        }
        this.groupsSearch = ''
        this.groupsPageIndex = 1
        this.groupsPageSize = 10
        this.handleGetShowRoleList()
      }
    },

    handleClear() {
      this.remoteMethod()
    },
  },
  watch: {
    'data.options.type'(v, oldVal) {
      // oldVal修复老时间组件无法选择开始结束时间
      if (oldVal) {
        if (this.data.type === 'date') {
          if (v === 'date' || v === 'daterange') {
            this.data.options.format = 'yyyy-MM-dd'
          } else if (v === 'datetime' || v === 'datetimerange') {
            this.data.options.format = 'yyyy-MM-dd HH:mm:ss'
          } else if (v === 'month') {
            this.data.options.format = 'yyyy-MM'
          }
          if (this.currentModel === this.data.model) {
            // 修复同个日期组件切换datetime后开始结束时间点击报错
            this.data.options.startDate = ''
            this.data.options.endDate = ''
          }
          this.currentModel = this.data.model
        }
      }
    },
    data: {
      handler() {
        if (
          this.data.type === 'sonform' &&
          this.data.list &&
          this.data.list.length
        ) {
          this.data.list.forEach(item => {
            const opt = item.options
            if (
              Object.prototype.hasOwnProperty.call(opt, 'props') &&
              Object.prototype.hasOwnProperty.call(opt.props, 'cascadeList')
            ) {
              opt.props.cascadeList = this.data.options.props.cascadeList
            }
          })
        }
        if (this.data.type === 'organization' && this.data.options.orgRootId) {
          this.data.options.remoteUrl = '/v1/process/getSubAllOrganizations'
        }
        if (this.data.type === 'organization' && !this.data.options.orgRootId) {
          this.data.options.remoteUrl = '/v1/institution/selectInsList'
        }

        if (
          this.data.type === 'sonform' &&
          !Object.prototype.hasOwnProperty.call(
            this.data.options,
            'numberTitle'
          )
        ) {
          this.data.options = {
            ...this.data.options,
            numberTitle: '序号',
          }
        }

        if (this.data.type === 'page') {
          if (
            this.data.options.selectPage &&
            this.sonPages &&
            this.sonPages[this.data.options.selectPage]
          ) {
            this.pageFields = formUtils.getComponentsListInfo(
              this.sonPages[this.data.options.selectPage].list
            )
          }
        }
      },
      deep: true,
      immediate: true,
    },
    'data.model': {
      handler() {
        this.changeValue++
      },
      immediate: true,
    },
    'data.options.remoteUrl': {
      handler() {
        // console.log(val);
      },
      immediate: true,
    },
    'data.options.props.cascadeList': {
      handler(val) {
        if (
          Object.prototype.hasOwnProperty.call(
            this.data.options,
            'initialValue'
          )
        ) {
          this.keyValue++
          if (this.data.options.props) {
            this.data.options.props.cascadeList = val
          }
        }
      },
      deep: true,
      immediate: true,
    },
    'data.options.props.cascaderVal': {
      handler() {
        if (
          this.data.type === 'sonform' &&
          this.data.options.props.cascaderVal.length === 0
        ) {
          if (this.data.list && this.data.list.length) {
            this.data.list.forEach(item => {
              item.options.props.cascaderVal = []
            })
          }
        }
      },
      deep: true,
      immediate: true,
    },
    'data.options.languageList': {
      handler(val) {
        if (this.data.type === 'textarea') {
          this.languageListLength = val.length
          // console.log('languageList.length',this.data.options.languageList.length);
        }
      },
      immediate: true,
    },
    'data.options.isRange': function (val) {
      if (typeof val !== 'undefined') {
        if (val) {
          this.data.options.defaultValue = null
        } else {
          if (Object.keys(this.data.options).indexOf('defaultValue') >= 0) {
            this.data.options.defaultValue = ''
          }
        }
      }
    },
    'data.options.required': function (val) {
      this.validateRequired(val)
    },
    'data.options.dataType': function (val) {
      this.validateDataType(val)
    },
    'data.options.pattern': function (val) {
      this.valiatePattern(val)
    },
    'data.name': function () {
      if (this.data.options) {
        this.validateRequired(this.data.options.required)
        this.validateDataType(this.data.options.dataType)
        this.valiatePattern(this.data.options.pattern)
      }
    },
    'data.key': function () {
      if (
        typeof this.formInfo.id !== 'undefined' &&
        this.formInfo.id &&
        Object.keys(this.data.options).indexOf('appId') >= 0 &&
        !this.data.options.appId
      ) {
        this.data.options.appId = this.formInfo.id
      }
      if (
        this.data.options.optionType === 'dictionary' ||
        Object.keys(this.data.options).indexOf('options') >= 0
      ) {
        if (
          (this.dicType.list === null || this.dicType.list.length <= 0) &&
          this.dicType.page === 1
        ) {
          // 如果字典类型 list 为空 则 查询一次
          this.dicType.id = this.formInfo.id
          widgetConfigUtils.queryDicTypeList(this.dicType)
        }
      }
    },
  },
}
</script>

<style lang="scss">
.widget-config-container .config-content .el-form-item__label {
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.sw-remote-api {
  margin-bottom: 5px;
}

.sw-remote-label {
  float: left;
  height: 32px;
  font-size: 12px;
  background-color: #f5f7fa;
  color: #909399;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 50px;
  margin-right: -5px;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
}

.sw-config-select {
  width: 100%;
}

.sw-custom-btn {
  margin-left: 10px;
}

.sw-custom-field {
  border-radius: 6px;
  float: left;
  color: white;
  background-color: #409eff;
  margin-left: 10px;
  margin-bottom: 5px;
}

.sw-custom-field span {
  padding: 6px;
}

.custom_span {
  display: inline-block;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.car-number-form-item {
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .theme {
      display: flex;
    }
  }
}

:deep(.input-with-color) {
  width: 130px;
  .el-input-group__append {
    padding: 0 5px !important;
  }

  .el-color-picker__trigger {
    border: none !important;
  }
}

.el-select-group {
}
</style>
